var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocationOnGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 5.5C11.13 5.5 8 8.63 8 12.5C8 16.67 12.42 22.42 14.24 24.61C14.64 25.09 15.37 25.09 15.77 24.61C17.58 22.42 22 16.67 22 12.5C22 8.63 18.87 5.5 15 5.5ZM15 15C13.62 15 12.5 13.88 12.5 12.5C12.5 11.12 13.62 10 15 10C16.38 10 17.5 11.12 17.5 12.5C17.5 13.88 16.38 15 15 15Z",
    fill: "#8C99B3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationOnGray);
export default __webpack_public_path__ + "static/media/location_on_gray.54a57102db09e53ce90f17f086ed754b.svg";
export { ForwardRef as ReactComponent };